import React from 'react'

// SAP Services zur Auswahl
import SapServiceCallTheTruck from 'gatsby-theme-kn/src/components/technical/SapServiceCallTheTruck'
import SapServiceOrders from 'gatsby-theme-kn/src/components/technical/SapServiceOrders'
import SapServiceOrderDetail from 'gatsby-theme-kn/src/components/technical/SapServiceOrderDetail'
import SapServiceOrderStatus from 'gatsby-theme-kn/src/components/technical/SapServiceOrderStatus'
import SapServiceDeliveryTimes from 'gatsby-theme-kn/src/components/technical/SapServiceDeliveryTimes'
import SapServiceTransactionRanking from 'gatsby-theme-kn/src/components/technical/SapServiceTransactionRanking'
import SapServiceDeliveryStatus from 'gatsby-theme-kn/src/components/technical/SapServiceDeliveryStatus'
import SapServiceDeliveryStatusRoute from 'gatsby-theme-kn/src/components/technical/SapServiceDeliveryStatusRoute'
import SapServiceDeliveryStatusRouteDetail from 'gatsby-theme-kn/src/components/technical/SapServiceDeliveryStatusRouteDetail'
import SapServiceFittingCalculation from 'gatsby-theme-kn/src/components/technical/SapServiceFittingCalculation'
// Mediendatenbank
import MediaDatabase from 'gatsby-theme-kn/src/components/technical/MediaDatabase'

// GET-Params
import queryString from 'query-string'
let params = {}
if (typeof window !== 'undefined') {
  params = queryString.parse(location.search)
}

const SapServiceBlock = ({ block }) => {
  return (
    <section className="spa-block">
      <div className="spa-block-container">
        <div className="spa-block-wrapper">
          {block?.service === 'call_the_truck' && <SapServiceCallTheTruck />}
          {block?.service === 'orders' && !params?.id && <SapServiceOrders />}
          {block?.service === 'orders' && params?.id && (
            <SapServiceOrderDetail orderId={params.id} />
          )}
          {block?.service === 'delivery_times' && <SapServiceDeliveryTimes />}
          {block?.service === 'transaction_ranking' && (
            <SapServiceTransactionRanking />
          )}
          {block?.service === 'order_status' && <SapServiceOrderStatus />}
          {block?.service === 'delivery_status' && !params?.route && (
            <SapServiceDeliveryStatus />
          )}
          {block?.service === 'delivery_status' && params?.route && (
            <>
              <SapServiceDeliveryStatusRoute
                routeId={params.route}
                customerNumber={params.customer_number}
              />
              <SapServiceDeliveryStatusRouteDetail
                routeId={params.route}
                customerNumber={params.customer_number}
              />
            </>
          )}
          {block?.service === 'fitting_calculation' && (
            <SapServiceFittingCalculation />
          )}
          {block?.service === 'media_database' && (
            <MediaDatabase params={params} />
          )}
          {block?.service === 'promotional_literature' && (
            <MediaDatabase params={params} isPromotialOrder={true} />
          )}
        </div>
      </div>
      {/* <pre>{JSON.stringify(block, null, 2)}</pre> */}
    </section>
  )
}

export default SapServiceBlock
